import { useUpdateAlertStatus } from '@/api/update-alert.hook'
import { AlertStatus } from '@/gen/inventory/v1/alert_pb'

import { useStatusSelector } from '@/hooks/use-status-selector'

import { EventProperties, useTrackCallback } from '@/lib/analytics/events'

import { alertStatusSelectorConfig } from '@/components/shared/select-alert-status-badge/consts'
import { SubmitSelect } from '@/components/shared/submit-select/submit-select'

interface SelectAlertStatusBadgeProps {
  alertId: string
  status: AlertStatus
  extraTrackingProps?: EventProperties
  readOnly?: boolean
}

export const SelectAlertStatusBadge = ({
  alertId,
  status,
  extraTrackingProps,
  readOnly = false,
}: SelectAlertStatusBadgeProps) => {
  const updateMutation = useUpdateAlertStatus(alertId)
  const trackUpdate = useTrackCallback('alert.status.update')

  const { statusBadge, isReadOnly, menuItems, handleSave, handleSendComment } = useStatusSelector({
    status,
    dependencies: {
      updateMutation,
      trackingCallback: trackUpdate,
      entityId: alertId,
      config: alertStatusSelectorConfig,
    },
    extraTrackingProps,
    readOnly,
  })

  // Alerts should not be opened after being dealt with because this will cause problems with the control mechanism.
  // https://www.notion.so/lema-ai/Controls-Flow-and-Logic-f93d08f8e23c481db91ae510ccc6b8ea?pvs=4#a69e04c84b81411fad58f3053af59e93
  if (isReadOnly) {
    return statusBadge
  }

  return (
    <SubmitSelect
      triggerAppearance='headless'
      value={status}
      title='Set the work status for this item'
      onSave={handleSave}
      onSendComment={handleSendComment}
      menuItems={menuItems}
    />
  )
}
